import React from "react";

export default function CookiePolicyPage() {

  return <iframe src="https://app.termly.io/policy-viewer/policy.html?policyUUID=de51088f-8818-4c64-98c9-acbb79926b25"
                 width="100%"
                 height="3850px" />

}